import { DocumentListItem } from './DocumentListItem';

export function DocumentsList({ documents, deleting, onDeleteClick, onViewClick }) {
  if (documents.length === 0) {
    return (
      <div data-testid="documents-empty-state" className="py-12 text-center text-muted-foreground">
        Aucun document ne correspond aux filtres
      </div>
    );
  }

  return (
    <div className="space-y-3" data-testid="documents-list">
      {documents.map((document) => (
        <DocumentListItem
          key={document.id}
          document={document}
          deleting={deleting}
          onDeleteClick={onDeleteClick}
          onViewClick={onViewClick}
        />
      ))}
    </div>
  );
}
